module.exports = __webpack_public_path__ + "1b1f722a7b7add2e62e376a32b9049f4.mp3";


//////////////////
// WEBPACK FOOTER
// ./assets/sounds/background/ocean.mp3
// module id = 3872
// module chunks = 0